import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import ResetPassword from './ResetPassword';
import LiveSchedule from '../Teacher/LiveSchedule';
import DemoAvailability from '../Teacher/DemoAvailability';
import PaidAvailability from '../Teacher/PaidAvailability';
import StudentsList from './MyStudents';
import './TeacherProfile.css';

const TeacherProfile = () => {
  const { id } = useParams();
  const [teacher, setTeacher] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState();
  const [showStatusModal, setShowStatusModal] = useState(false);

  useEffect(() => {
    const fetchTeacher = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/admin/teacherprofile/${id}`,
                  { headers: { 'Authorization': `Bearer ${localStorage.getItem('userData')}` } }

        );
        setTeacher(response.data);
        setError(null);
      } catch (err) {
        setError(err.response?.data?.error || err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTeacher();
  }, [id]);
  const userData = {

    id: id

  };

console.log(userData);
  const handleStatusChange = async () => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/teacherprofile/${id}/status`,
        { isActive: !teacher.IsActive },
                { headers: { 'Authorization': `Bearer ${localStorage.getItem('userData')}` } }

      );
      setTeacher({ ...teacher, IsActive: !teacher.IsActive });
      setShowStatusModal(false);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  if (loading) {
    return <div className="teacher-profile__loading">Loading...</div>;
  }

  if (error) {
    return <div className="teacher-profile__error">Error: {error}</div>;
  }

  if (!teacher) {
    return <div className="teacher-profile__not-found">Teacher not found</div>;
  }

  return (
    <div className="teacher-profile">
      {/* Status Change Confirmation Modal */}
      {showStatusModal && (
        <div className="teacher-profile__modal">
          <div className="teacher-profile__modal-content">
            <h3>Confirm Status Change</h3>
            <p>Are you sure you want to set this teacher as {teacher.IsActive ? 'inactive' : 'active'}?</p>
            <div className="teacher-profile__modal-actions">
              <button 
                className="teacher-profile__modal-btn teacher-profile__modal-btn--confirm"
                onClick={handleStatusChange}
              >
                Yes
              </button>
              <button 
                className="teacher-profile__modal-btn teacher-profile__modal-btn--cancel"
                onClick={() => setShowStatusModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="teacher-profile__header">
        <div className="teacher-profile__image-container">
          <img 
            src={teacher.Image || "../../assets/img/student.jpg"} 
            alt={`${teacher.FirstName} ${teacher.LastName}`}
            className="teacher-profile__image"
          />
        </div>
        <div className="teacher-profile__info">
          <h1 className="teacher-profile__name">
            {teacher.FirstName} {teacher.LastName} (Teacher)
          </h1>
          <p className="teacher-profile__email">Email: {teacher.Email}</p>
          <p className="teacher-profile__email">Username: {teacher.Username}</p>

          <p className="teacher-profile__phone">Mobile: {teacher.MobileNumber}</p>
          <p className="teacher-profile__birthday">
            Birthday: {new Date(teacher.Birthday).toLocaleDateString()}
          </p>
          <div className={`teacher-profile__status ${teacher.IsActive ? 'active' : 'inactive'}`}>
            {teacher.IsActive ? 'Active' : 'Inactive'}
          </div>
        </div>
      </div>

      <div className="teacher-profile__tabs">
       
        
        <button
          className={`teacher-profile__tab ${activeTab === 'reset' ? 'active' : ''}`}
          onClick={() => setActiveTab('reset')}
        >
          Reset Password
        </button>
        <button
          className={`teacher-profile__tab ${activeTab === 'calendar' ? 'active' : ''}`}
          onClick={() => setActiveTab('calendar')}
        >
          Live Calendar
        </button>
        <button
          className={`teacher-profile__tab ${activeTab === 'demo' ? 'active' : ''}`}
          onClick={() => setActiveTab('demo')}
        >
          Demo Availability
        </button>
        <button
          className={`teacher-profile__tab ${activeTab === 'paid' ? 'active' : ''}`}
          onClick={() => setActiveTab('paid')}
        >
          Paid Availability
        </button>
        <button
          className={`teacher-profile__tab ${activeTab === 'earnings' ? 'active' : ''}`}
          onClick={() => setActiveTab('earnings')}
        >
          Earnings
        </button>
        <button
          className={`teacher-profile__tab ${activeTab === 'students' ? 'active' : ''}`}
          onClick={() => setActiveTab('students')}
        >
          Students
        </button>
        
      </div>

      <div className="teacher-profile__content">
        {activeTab === 'info' && (
          <div className="teacher-profile__info-view">
            {/* Display basic info */}
          </div>
        )}
        {activeTab === 'reset' && <ResetPassword teacherId={id} />}
        {activeTab === 'calendar' && <LiveSchedule userData={userData} />}
        {activeTab === 'demo' && <DemoAvailability userData={userData} />}
        {activeTab === 'paid' && <PaidAvailability userData={userData}  />}
        {activeTab === 'students' && <StudentsList userData={userData} />}
      </div>
    </div> 
  );
};

export default TeacherProfile;